import { Flex, ThemeIcon, Text } from '@mantine/core';
import React from 'react';
import CountUpAnimation from './CountUpAnimation';
import colors from '../utils/colors';
import { useLanguage } from '../context/LanguageContext';

interface StatItemProps {
  icon: React.ReactNode;
  value: string;
  unit: string;
  description: string;
  gradient: {
    from: string;
    to: string;
    deg?: number;
  };
}

export const StatItem: React.FC<StatItemProps> = ({ icon, value, unit, description, gradient }) => {
  const { translate } = useLanguage();
  
  const numericValue = parseFloat(value) || 0;
  
  return (
    <Flex direction="row" gap={10}>
      <ThemeIcon
        variant="gradient"
        size="xl"
        radius="lg"
        gradient={gradient}
      >
        {icon}
      </ThemeIcon>
      <Flex direction="column">
        {unit === translate('minutes') ? (
          <Text variant="gradient" gradient={gradient} fw={700} fz="h4" component="div">
            <CountUpAnimation 
              end={Math.floor(numericValue / 60)}
              duration={1.5} 
              delay={0} 
              suffix={` ${translate('minutes')}`}
            />
          </Text>
        ) : (
          <Text variant="gradient" gradient={gradient} fw={700} fz="h4" component="div">
            <CountUpAnimation 
              end={numericValue}
              duration={1.5} 
              delay={0}
              decimals={numericValue % 1 !== 0 ? 2 : 0}
              suffix={` ${unit}`}
            />
          </Text>
        )}
        <Text mt={-8} c={colors.custom36s} fw={500} fz="h5">{description}</Text>
      </Flex>
    </Flex>
  );
};